export default __webpack_public_path__ + "static/media/chatxx.8cb4d767.gif";